/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * odpowiedz serwera
 */
export interface NewsletterResponse { 
    state?: NewsletterResponse.StateEnum;
}
export namespace NewsletterResponse {
    export type StateEnum = 'SAVE' | 'EXIST' | 'ERROR';
    export const StateEnum = {
        SAVE: 'SAVE' as StateEnum,
        EXIST: 'EXIST' as StateEnum,
        ERROR: 'ERROR' as StateEnum
    };
}


